export enum SocialLoginType {
  Amazon = 'amazon',
}
export const allowedCORForAmazonLinking: string[] = ['us', 'cx', 'cv', 'pr'];
